// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0e817b9b","703":"d09cabe3","787":"7e80e009"}[chunkId] + ".chunk.js";
};